/* eslint-disable line-comment-position */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { StyledEngineProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import { MainTheme } from './theme';
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import packageJson from '../package.json';

import { CustomToastContainer } from './components/CustomToastContainer';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

Sentry.init({
  dsn: 'https://b34402d13467494caa6dfe5930c3c2dc@o1252268.ingest.sentry.io/6418319',
  release: `vipr-ui@${packageJson.version}`,
  environment: process.env.REACT_APP_ENV,

  // integrations: [new Sentry.BrowserTracing({ tracingOrigins: ['*'] }), new Sentry.Replay()],
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay({})],
  // Performance Monitoring
  tracesSampleRate: Number(process.env.REACT_APP_SENTRY_SAMPLE_RATE) || 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAY_SAMPLE_RATE) || 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE) || 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <MainTheme>
        <HelmetProvider>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <Provider store={store}>
              <App />
            </Provider>
          </SnackbarProvider>
          <CustomToastContainer />
        </HelmetProvider>
      </MainTheme>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
